export default {"src":"/_next/static/media/google.51f25470.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};